import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {
  imageObject = [{
    image: 'assets/images/gallery/1.jpg',
    thumbImage: 'assets/images/gallery/1.jpg',
  },
  {
    image: 'assets/images/gallery/3.jpg',
    thumbImage: 'assets/images/gallery/3.jpg',
  },
  {
    image: 'assets/images/gallery/5.jpg',
    thumbImage: 'assets/images/gallery/5.jpg'
  },
  {
    image: 'assets/images/gallery/6.jpg',
    thumbImage: 'assets/images/gallery/6.jpg',
  },
  {
    image: 'assets/images/gallery/8.jpg',
    thumbImage: 'assets/images/gallery/8.jpg'
  },
  {
    image: 'assets/images/gallery/9.jpg',
    thumbImage: 'assets/images/gallery/9.jpg',
  },
  {
    image: 'assets/images/gallery/01.jpg',
    thumbImage: 'assets/images/gallery/01.jpg'
  },
  {
    image: 'assets/images/gallery/02.jpg',
    thumbImage: 'assets/images/gallery/02.jpg',
  },
  {
    image: 'assets/images/gallery/02.jpg',
    thumbImage: 'assets/images/gallery/01.jpg'
  },
  {
    image: 'assets/images/gallery/03.jpg',
    thumbImage: 'assets/images/gallery/03.jpg'
  },
  {
    image: 'assets/images/gallery/04.jpg',
    thumbImage: 'assets/images/gallery/04.jpg'
  },
  {
    image: 'assets/images/gallery/11.jpg',
    thumbImage: 'assets/images/gallery/11.jpg'
  },
  {
    image: 'assets/images/gallery/12.jpg',
    thumbImage: 'assets/images/gallery/12.jpg',
  },
  {
    image: 'assets/images/gallery/13.jpg',
    thumbImage: 'assets/images/gallery/13.jpg',
  },
  {
    image: 'assets/images/gallery14.jpg',
    thumbImage: 'assets/images/gallery/14.jpg'
  },
  {
    image: 'assets/images/gallery/15.jpg',
    thumbImage: 'assets/images/gallery/15.jpg',
  },
  {
    image: 'assets/images/gallery/16.jpg',
    thumbImage: 'assets/images/gallery/16.jpg',
  },
  {
    image: 'assets/images/gallery/17.jpg',
    thumbImage: 'assets/images/gallery/17.jpg',
  },
  {
    image: 'assets/images/gallery/18.jpg',
    thumbImage: 'assets/images/gallery/18.jpg'
  },
  {
    image: 'assets/images/gallery/19.jpg',
    thumbImage: 'assets/images/gallery/19.jpg',
  },
  {
    image: 'assets/images/gallery/20.jpg',
    thumbImage: 'assets/images/gallery/20.jpg',
  },
  {
    image: 'assets/images/gallery/21.jpg',
    thumbImage: 'assets/images/gallery/21.jpg'
  },
  {
    image: 'assets/images/gallery/23.jpg',
    thumbImage: 'assets/images/gallery/23.jpg'
  },
  {
    image: 'assets/images/gallery/24.jpg',
    thumbImage: 'assets/images/gallery/24.jpg'
  },
  {
    image: 'assets/images/gallery/26.jpg',
    thumbImage: 'assets/images/gallery/26.jpg',
  },
  {
    image: 'assets/images/gallery/27.jpg',
    thumbImage: 'assets/images/gallery/27.jpg',
  },
  {
    image: 'assets/images/gallery/28.jpg',
    thumbImage: 'assets/images/gallery/28.jpg'
  },
  {
    image: 'assets/images/gallery/29.jpg',
    thumbImage: 'assets/images/gallery/29.jpg'
  },
  {
    image: 'assets/images/gallery/30.jpg',
    thumbImage: 'assets/images/gallery/30.jpg',
  },
  {
    image: 'assets/images/gallery/31.jpg',
    thumbImage: 'assets/images/gallery/31.jpg',
  },
  {
    image: 'assets/images/gallery/32.jpg',
    thumbImage: 'assets/images/gallery/32.jpg'
  },
  {
    image: 'assets/images/gallery/33.jpg',
    thumbImage: 'assets/images/gallery/33.jpg'
  },
  ];

}



